export enum PostureStatus {
  Passed = 'Passed',
  Failed = 'Failed',
}
